export const OTHER_NON_CASH_BENEFIT = 1 << 7

export const NON_CASH_BENEFIT_OPTIONS = [
  { value: 1 << 0, label: "WIC" },
  { value: 1 << 1, label: "Childcare Voucher" },
  { value: 1 << 2, label: "Affordable Care Subsidy" },
  { value: 1 << 3, label: "Section 8 Voucher" },
  { value: 1 << 4, label: "Permanent Housing Support" },
  { value: 1 << 5, label: "Public Housing Authority" },
  { value: 1 << 6, label: "VA Supportive Housing" },
  { value: OTHER_NON_CASH_BENEFIT, label: "Other" },
] as const

export function hasNonCashBenefit(mask: number, value: number): boolean {
  return (mask & value) !== 0
}

export function setNonCashBenefit(mask: number, value: number, selected: boolean): number {
  return selected ? mask | value : mask & ~value
}
